import {
  NUMBER_SHARE_REQUEST,
  NUMBER_SHARE_SUCCESS,
  NUMBER_SHARE_ERROR,
  SERVICE_NUMBER_SHARE_REQUEST,
  SERVICE_NUMBER_SHARE_SUCCESS,
  SERVICE_NUMBER_SHARE_ERROR,
  NUMBER_SHARE_ELIGIBILITY_REQUEST,
  NUMBER_SHARE_ELIGIBILITY_SUCCESS,
  NUMBER_SHARE_ELIGIBILITY_ERROR
} from './actionTypes';

export const getNumberShare = {
  request: () => ({ type: NUMBER_SHARE_REQUEST }),
  success: (data) => ({ type: NUMBER_SHARE_SUCCESS, data }),
  failure: (error) => ({ type: NUMBER_SHARE_ERROR, error })
};

export const getServiceNumberShare = {
  request: () => ({ type: SERVICE_NUMBER_SHARE_REQUEST }),
  success: (data) => ({ type: SERVICE_NUMBER_SHARE_SUCCESS, data }),
  failure: (error) => ({ type: SERVICE_NUMBER_SHARE_ERROR, error })
};

export const getNumberShareEligibility = {
  request: (serviceNo, callback) => ({
    type: NUMBER_SHARE_ELIGIBILITY_REQUEST,
    serviceNo,
    callback
  }),
  success: (data) => ({ type: NUMBER_SHARE_ELIGIBILITY_SUCCESS, data }),
  failure: (error) => ({ type: NUMBER_SHARE_ELIGIBILITY_ERROR, error })
};
